<template lang="pug">
  #scatter-selection
    .container.p-0
      p.selection-label.mt-3.mb-2.ml-2 Poblaciones más vulnerables en
      b-form-select.states(v-model="selectedState" :options="states" @change="changeState")
      span.arrow
      .row.condition.mx-2.d-flex.flex-column(v-for="tasa in stateData")
        p.tasa.mb-0.mt-4 {{ round(tasa.number) }}
        p.condition-label.mb-0(:class="tasa.condition") {{ tasa.text }}
        p.tasa-info por cada 10 mil habitantes

</template>
<script>
import * as d3 from "d3";
import * as _ from "lodash";

export default {
  name: "ScatterSelection",
  data() {
    return {
      data: "",
      stateData: "",
      states: []
    };
  },
  computed: {
    selectedState: {
      get() {
        return this.$store.state.ch3SelectedState;
      },
      set(value) {
        this.$store.state.ch3SelectedState = value;
      }
    }
  },
  watch: {
    selectedState() {
      this.changeState();
    }
  },
  methods: {
    round(num) {
      return _.round(Number(num), 2);
    },
    changeState() {
      this.stateData = this.data.filter(d => {
        return d.cve_geo === this.selectedState;
      }).map(d => {
        return [
          {
            condition: "diabetes",
            number: Number(d.tasa_diabetes),
            text: "personas con diabetes"
          },
          {
            condition: "hiv",
            number: Number(d.tasa_VIH),
            text: "personas con VIH"
          },
          {
            condition: "obesity",
            number: Number(d.tasa_obesidad),
            text: "personas con obesidad"
          },
          {
            condition: "kidney",
            number: Number(d.tasa_riñon),
            text: "personas con enfermedades de riñón"
          },
          {
            condition: "smokers",
            number: Number(d.tasa_fumador),
            text: "personas fumadoras"
          }
        ]
      })[0];
      
      this.stateData.sort((a, b) => b.number - a.number);
    }
  },
  async mounted() {
    this.data = await d3.csv("/assets/csv/chapter2/base_tasas.csv");
    this.states = this.data.map(d => {
      return { text: d.entidad, value: d.cve_geo };
    });
    this.changeState();
  }
};
</script>
<style lang="scss">
#scatter-selection {
  .selection-label {
    font-family: Oswald;
    font-size: 15px;
    color: white;
  }
  .states {
    min-width: 100%;
    border-radius: 8px;
    border: solid 2px #ffffff;
    background-color: #0a1d59;
    color: white;
    height: 45px;
    font-size: 18px;
  }
  .arrow:after {
    font-family: "FontAwesome";
    content: "\f0d7";
    margin-left: -25px;
    padding: 0.1em;
    pointer-events: none;
    position: relative;
    top: 2px;
    font-size: 19px;
    color: white;
  }
  .diabetes {
    color: #ffd58a;
  }
  .hiv {
    color: #34afb2;
  }
  .obesity {
    color: #ff6561;
  }
  .kidney {
    color: #f7b3aa;
  }
  .smokers {
    color: #78d4e1;
  }
  .tasa {
    font-family: Oswald;
    color: white;
    font-weight: bold;
    font-size: 28px;
  }
  .condition-label {
    font-weight: bold;
    font-family: Oswald;
  }
  .tasa-info {
    font-family: Oswald;
    color: white;
    font-size: 15px;
  }
}
</style>
